export type Option = {
  text: string;
  scores?: { category: string; points: number }[];
};

export type Question = {
  text: string;
  options: Array<Option>;
  image: string;
};

export type Archetype = {
  title: string;
  caption?: string;
  description: string;
  img: string;
  summary: string;
};

export const QUIZ_QUESTIONS_A: Question[] = [
  {
    text: "Ideal outdoor day?",
    image:
      "https://images.prismic.io/imtbl-player-portal/Z6KvqZbqstJ9-OxU_rq_outdoor.gif?auto=format,compress",
    options: [
      {
        text: "Perfecting my bow aim",
        scores: [
          { category: "Precision - Archery", points: 3 },
          { category: "Precision - Shadow", points: 1 },
        ],
      },
      {
        text: "Battling in the wilderness",
        scores: [
          { category: "Fortitude - Warfare", points: 3 },
          { category: "Magic - Wizardry", points: 1 },
        ],
      },
      {
        text: "Practicing healing & protection spells",
        scores: [
          { category: "Fortitude - Holy", points: 3 },
          { category: "Fortitude - Protection", points: 1 },
        ],
      },
      {
        text: "Connecting with the spiritual world",
        scores: [
          { category: "Magic - Witchcraft", points: 3 },
          { category: "Magic - Spiritual", points: 1 },
        ],
      },
    ],
  },
  {
    text: "Dream superpower?",
    image:
      "https://images.prismic.io/imtbl-player-portal/Z6Kw7ZbqstJ9-OxZ_rq_superpower.gif?auto=format,compress",
    options: [
      {
        text: "Super strength",
        scores: [
          { category: "Magic - Spiritual", points: 3 },
          { category: "Fortitude - Warfare", points: 1 },
        ],
      },
      {
        text: "Flight",
        scores: [
          { category: "Magic - Wizardry", points: 3 },
          { category: "Precision - Archery", points: 1 },
        ],
      },
      {
        text: "Invisibility",
        scores: [
          { category: "Precision - Shadow", points: 3 },
          { category: "Magic - Witchcraft", points: 1 },
        ],
      },
      {
        text: "Bullet proof skin",
        scores: [
          { category: "Fortitude - Protection", points: 3 },
          { category: "Fortitude - Holy", points: 1 },
        ],
      },
    ],
  },
  {
    text: "Weapon of choice?",
    image:
      "https://images.prismic.io/imtbl-player-portal/Z6KyX5bqstJ9-Ox0_rq_weapon_cropped.gif?auto=format,compress",
    options: [
      {
        text: "A holy hammer",
        scores: [
          { category: "Fortitude - Holy", points: 3 },
          { category: "Magic - Spiritual", points: 1 },
        ],
      },
      {
        text: "A demonic rapier",
        scores: [
          { category: "Fortitude - Warfare", points: 3 },
          { category: "Precision - Shadow", points: 1 },
        ],
      },
      {
        text: "A sleek lance",
        scores: [
          { category: "Precision - Archery", points: 3 },
          { category: "Fortitude - Protection", points: 1 },
        ],
      },
      {
        text: "An arcane magic wand",
        scores: [
          { category: "Magic - Witchcraft", points: 3 },
          { category: "Magic - Wizardry", points: 1 },
        ],
      },
    ],
  },
  {
    text: "Go-to snack?",
    image:
      "https://images.prismic.io/imtbl-player-portal/Z6KyWZbqstJ9-Oxz_rq_snack_cropped.gif?auto=format,compress",
    options: [
      {
        text: "A protein smoothie",
        scores: [
          { category: "Magic - Spiritual", points: 3 },
          { category: "Fortitude - Warfare", points: 1 },
        ],
      },
      {
        text: "A hefty sandwich",
        scores: [
          { category: "Fortitude - Protection", points: 3 },
          { category: "Fortitude - Holy", points: 1 },
        ],
      },
      {
        text: "Edible crystal candy",
        scores: [
          { category: "Magic - Wizardry", points: 3 },
          { category: "Magic - Witchcraft", points: 1 },
        ],
      },
      {
        text: "A muesli bar",
        scores: [
          { category: "Precision - Shadow", points: 3 },
          { category: "Precision - Archery", points: 1 },
        ],
      },
    ],
  },
  {
    text: "Summoned sidekick?",
    image:
      "https://images.prismic.io/imtbl-player-portal/Z6Kw6pbqstJ9-OxY_rq_summon.gif?auto=format,compress",
    options: [
      {
        text: "An undead warrior",
        scores: [
          { category: "Fortitude - Warfare", points: 3 },
          { category: "Magic - Wizardry", points: 1 },
        ],
      },
      {
        text: "A falcon",
        scores: [
          { category: "Precision - Archery", points: 3 },
          { category: "Precision - Shadow", points: 1 },
        ],
      },
      {
        text: "A stone golem",
        scores: [
          { category: "Fortitude - Holy", points: 3 },
          { category: "Fortitude - Protection", points: 1 },
        ],
      },
      {
        text: "A serpent",
        scores: [
          { category: "Magic - Witchcraft", points: 3 },
          { category: "Magic - Spiritual", points: 1 },
        ],
      },
    ],
  },
  {
    text: "I recover by...",
    image:
      "https://images.prismic.io/imtbl-player-portal/Z6KyiJbqstJ9-Ox2_rq_energy_cropped.gif?auto=format,compress",
    options: [
      {
        text: "Studying spellbooks",
        scores: [
          { category: "Magic - Wizardry", points: 3 },
          { category: "Magic - Witchcraft", points: 1 },
        ],
      },
      {
        text: "Polishing my armor",
        scores: [
          { category: "Fortitude - Protection", points: 3 },
          { category: "Fortitude - Warfare", points: 1 },
        ],
      },
      {
        text: "Meditating",
        scores: [
          { category: "Magic - Spiritual", points: 3 },
          { category: "Precision - Archery", points: 1 },
        ],
      },
      {
        text: "Napping in the trees",
        scores: [
          { category: "Precision - Shadow", points: 3 },
          { category: "Fortitude - Holy", points: 1 },
        ],
      },
    ],
  },
];

export const QUIZ_QUESTIONS_B: Question[] = [
  {
    text: "What's your ideal way to spend a quiet afternoon?",
    image: "",
    options: [
      {
        text: "Relaxing by the water, fishing rod in hand, a fire smouldering beside you",
        scores: [
          { category: "Extraction - Fishing", points: 3 },
          { category: "Extraction - Woodcutting", points: 1 },
        ],
      },
      {
        text: "Smelting ores you discovered and crafting sturdy tools",
        scores: [
          { category: "Crafting - Blacksmithing", points: 3 },
          { category: "Extraction - Mining", points: 1 },
        ],
      },
      {
        text: "Fixing things around your house then enjoying a hearty meal",
        scores: [
          { category: "Crafting - Carpentry", points: 3 },
          { category: "Crafting - Cooking", points: 1 },
        ],
      },
      {
        text: "Tending to your flock and providing for their needs",
        scores: [
          { category: "Agriculture - Moa Breeding", points: 3 },
          { category: "Crafting - Weaving", points: 1 },
        ],
      },
      {
        text: "Getting your hands dirty while working the land",
        scores: [
          { category: "Agriculture - Farming", points: 3 },
          { category: "Agriculture - Animal Husbandry", points: 1 },
        ],
      },
    ],
  },
  {
    text: "What's your go-to task for earning some extra coin?",
    image: "",
    options: [
      {
        text: "Felling trees, burning wood and making charcoal",
        scores: [
          { category: "Extraction - Woodcutting", points: 3 },
          { category: "Crafting - Blacksmithing", points: 1 },
        ],
      },
      {
        text: "Stitching together nets for the local fishermen",
        scores: [
          { category: "Crafting - Weaving", points: 3 },
          { category: "Extraction - Fishing", points: 1 },
        ],
      },
      {
        text: "Swinging a pickaxe in the mines and hoping for gold",
        scores: [
          { category: "Extraction - Mining", points: 3 },
          { category: "Crafting - Carpentry", points: 1 },
        ],
      },
      {
        text: "Cooking up delicious meals made with local ingredients",
        scores: [
          { category: "Crafting - Cooking", points: 3 },
          { category: "Agriculture - Farming", points: 1 },
        ],
      },
      {
        text: "Breeding animals that can be sold at the market",
        scores: [
          { category: "Agriculture - Animal Husbandry", points: 3 },
          { category: "Agriculture - Moa Breeding", points: 1 },
        ],
      },
    ],
  },
  {
    text: "How do you help your team in a high-stakes adventure?",
    image: "",
    options: [
      {
        text: "Crafting sturdy wagons to transport our spoils back home",
        scores: [
          { category: "Crafting - Carpentry", points: 3 },
          { category: "Extraction - Woodcutting", points: 1 },
        ],
      },
      {
        text: "Bring along bags of fresh produce to keep everyone energised",
        scores: [
          { category: "Agriculture - Farming", points: 3 },
          { category: "Crafting - Weaving", points: 1 },
        ],
      },
      {
        text: "Catching and preparing fish at every meal",
        scores: [
          { category: "Extraction - Fishing", points: 3 },
          { category: "Crafting - Cooking", points: 1 },
        ],
      },
      {
        text: "Training and outfitting our mounts to travel swiftly",
        scores: [
          { category: "Agriculture - Moa Breeding", points: 3 },
          { category: "Extraction - Mining", points: 1 },
        ],
      },
      {
        text: "Forging weapons and armor to protect the group",
        scores: [
          { category: "Crafting - Blacksmithing", points: 3 },
          { category: "Agriculture - Animal Husbandry", points: 1 },
        ],
      },
    ],
  },
  {
    text: "What's your ultimate creative outlet?",
    image: "",
    options: [
      {
        text: "Perfect the ultimate feast at the end of our adventures",
        scores: [
          { category: "Crafting - Cooking", points: 3 },
          { category: "Agriculture - Farming", points: 1 },
        ],
      },
      {
        text: "Designing lightweight armor that's functional and fashionable",
        scores: [
          { category: "Crafting - Weaving", points: 3 },
          { category: "Crafting - Carpentry", points: 1 },
        ],
      },
      {
        text: "Building a cozy log cabin in the middle of the forest",
        scores: [
          { category: "Extraction - Woodcutting", points: 3 },
          { category: "Agriculture - Moa Breeding", points: 1 },
        ],
      },
      {
        text: "Making my own equipment to catch legendary fish",
        scores: [
          { category: "Extraction - Mining", points: 3 },
          { category: "Extraction - Fishing", points: 1 },
        ],
      },
      {
        text: "Running a farm and tending to my livestock",
        scores: [
          { category: "Agriculture - Animal Husbandry", points: 3 },
          { category: "Crafting - Blacksmithing", points: 1 },
        ],
      },
    ],
  },
  {
    text: "How do you want to leave a mark on the world?",
    image: "",
    options: [
      {
        text: "Crafting legendary weapons and tools that are passed down for generations",
        scores: [
          { category: "Crafting - Blacksmithing", points: 3 },
          { category: "Crafting - Weaving", points: 1 },
        ],
      },
      {
        text: "Building the most exquisitely designed homes",
        scores: [
          { category: "Crafting - Carpentry", points: 3 },
          { category: "Agriculture - Animal Husbandry", points: 1 },
        ],
      },
      {
        text: "Winning first prize in all the animal shows",
        scores: [
          { category: "Agriculture - Moa Breeding", points: 3 },
          { category: "Extraction - Woodcutting", points: 1 },
        ],
      },
      {
        text: "Growing vast fields of crops that can feed entire villages",
        scores: [
          { category: "Agriculture - Farming", points: 3 },
          { category: "Extraction - Mining", points: 1 },
        ],
      },
      {
        text: "Catching all of the biggest and rarest fish",
        scores: [
          { category: "Extraction - Fishing", points: 3 },
          { category: "Crafting - Cooking", points: 1 },
        ],
      },
    ],
  },
  {
    text: "If you were to write a book about your adventures, what would it focus on?",
    image: "",
    options: [
      {
        text: "Telling the story of how I felled entire forests with my trusty axe",
        scores: [
          { category: "Extraction - Woodcutting", points: 3 },
          { category: "Extraction - Fishing", points: 1 },
        ],
      },
      {
        text: "All of the times my finely woven armor saved my companions from peril",
        scores: [
          { category: "Crafting - Weaving", points: 3 },
          { category: "Crafting - Carpentry", points: 1 },
        ],
      },
      {
        text: "The story of how I discovered the largest diamond ever unearthed",
        scores: [
          { category: "Extraction - Mining", points: 3 },
          { category: "Agriculture - Farming", points: 1 },
        ],
      },
      {
        text: "All of the recipes I discovered from cooking with exotic ingredients",
        scores: [
          { category: "Crafting - Cooking", points: 3 },
          { category: "Crafting - Blacksmithing", points: 1 },
        ],
      },
      {
        text: "Stories of the animal companions I tamed and how they helped our cause",
        scores: [
          { category: "Agriculture - Animal Husbandry", points: 3 },
          { category: "Agriculture - Moa Breeding", points: 1 },
        ],
      },
    ],
  },
];

export const QUIZ_QUESTIONS_C: Question[] = [
  {
    text: "What sets RavenQuest apart from most Web3 games?",
    image:
      "https://images.prismic.io/imtbl-player-portal/Z8aJ_RsAHJWomEz3_Munk1.png?auto=format,compress",
    options: [
      {
        text: "Play & earn mechanics exist",
      },
      {
        text: "It is a vast MMORPG",
      },
      {
        text: "Most content-rich, polished Web3",
        scores: [{ category: "default", points: 1 }],
      },
      {
        text: "Large player test base",
      },
    ],
  },
  {
    text: "What advanced anti-cheat measures protect RavenQuest players?",
    image:
      "https://images.prismic.io/imtbl-player-portal/Z8aKABsAHJWomEz4_Munk2.png?auto=format,compress",
    options: [
      {
        text: "Real-time detection systems used",
      },
      {
        text: "Advanced behavior analysis applied",
      },
      {
        text: "AnyBrain.gg anti-cheat integrated",
      },
      {
        text: "All listed methods are used",
        scores: [{ category: "default", points: 1 }],
      },
    ],
  },
  {
    text: "What is $QUEST and how do players get it?",
    image:
      "https://images.prismic.io/imtbl-player-portal/Z8aKARsAHJWomEz5_Munk3.png?auto=format,compress",
    options: [
      {
        text: "It's a in-game currency, bosses drop it",
      },
      {
        text: "$QUEST is the on-chain token. Earn or buy",
        scores: [{ category: "default", points: 1 }],
      },
      {
        text: "Rare collectible that grants special powers",
      },
      {
        text: "Wen $QUEST?",
      },
    ],
  },
  {
    text: "How do players actively shape the world and economy of RavenQuest?",
    image:
      "https://images.prismic.io/imtbl-player-portal/Z8aKAhsAHJWomEz6_Munk4.png?auto=format,compress",
    options: [
      {
        text: "Land ownership, customization options",
      },
      {
        text: "Crafting, gathering drives economy",
      },
      {
        text: "Guild wars impact politics/economy",
      },
      {
        text: "All of the above",
        scores: [{ category: "default", points: 1 }],
      },
    ],
  },
];

export const resultOptionsA: Record<string, Archetype> = {
  "Magic - Wizardry": {
    title: "Wizardry",
    description:
      "Bending ice and fire to your will, you devastate enemies. Your powerful single-target and area spells can shift the tide of battle. You are a truly arcane force.",
    img: "https://images.prismic.io/imtbl-player-portal/Z6KxUZbqstJ9-Oxj_rq_char_wizardry.gif?auto=format,compress",
    summary:
      "I bend ice and fire to devastate enemies with powerful single-target and AOE spells 🔥❄️",
  },
  "Magic - Witchcraft": {
    title: "Witchcraft",
    description:
      "Your archetype, originating from vampiric cults, mixes occult powers with the ability to exploit enemy weaknesses, making you incredibly dangerous.",
    img: "https://images.prismic.io/imtbl-player-portal/Z6KxWpbqstJ9-Oxk_rq_char_witchcraft.gif?auto=format,compress",
    summary:
      "I use occult powers to exploit enemy weaknesses and channel dark magic from vampiric cults 🌙",
  },
  "Magic - Spiritual": {
    title: "Spiritual",
    description:
      "Spiritually calm, you focus on the world's invisible threads. WIth a honed mind, you summon these forces to aid allies - protecting, hastening, and refreshing mana. You're an invaluable team member.",
    img: "https://images.prismic.io/imtbl-player-portal/Z6KxbZbqstJ9-Oxo_rq_char_spiritual.gif?auto=format,compress",
    summary:
      "I channel invisible forces to protect and empower my allies with mana and haste ✨",
  },
  "Fortitude - Warfare": {
    title: "Warfare",
    description:
      "You favor this archetype, as do orcs and barbarians. Specializing in brute force, you draw upon spilled lifeblood to heal and strengthen savage attacks. Bloodlust makes you terrifying.",
    img: "https://images.prismic.io/imtbl-player-portal/Z6KxXpbqstJ9-Oxm_rq_char_warfare.gif?auto=format,compress",
    summary:
      "I draw power from battle and spilled lifeblood to strengthen my savage attacks ⚔️",
  },
  "Fortitude - Holy": {
    title: "Holy",
    description:
      "As a wielder of White Magic, RavenQuest's primary healing archetype, you channel the Dawn's restorative light. While focused on keeping allies alive, your full power can smite enemies.",
    img: "https://images.prismic.io/imtbl-player-portal/Z6KxTZbqstJ9-Oxg_rq_char_holy.gif?auto=format,compress",
    summary:
      "I channel the Dawn's restorative light to heal allies and smite enemies 🌅",
  },
  "Fortitude - Protection": {
    title: "Protection",
    description:
      "Brave and strong, you never lose spirit. A master of the Ravenguard's preferred archetype, you defend allies and bash enemy skulls. Your morale is legendary.",
    img: "https://images.prismic.io/imtbl-player-portal/Z6KxTpbqstJ9-Oxh_rq_char_protection.gif?auto=format,compress",
    summary:
      "I defend my allies with unwavering spirit and legendary morale of the Ravenguard 🛡️",
  },
  "Precision - Archery": {
    title: "Archery",
    description:
      "You're hawk-eyed, outracing foes with speed and vision. A ranged combat expert, you unleash deadly arrows from afar. Disengage abilities create space for your killing shots. The Rohna Brotherhood's evasion of the Ravenguard owes much to this archetype.",
    img: "https://images.prismic.io/imtbl-player-portal/Z6KxTJbqstJ9-Oxf_rq_char_archery.gif?auto=format,compress",
    summary:
      "I unleash deadly arrows from afar with hawk-eyed precision and expert evasion 🏹",
  },
  "Precision - Shadow": {
    title: "Shadow",
    description:
      "You extinguish lives unseen, using toxins and deception to weaken targets before fatal blows. You're a harbinger of death.",
    img: "https://images.prismic.io/imtbl-player-portal/Z6KxT5bqstJ9-Oxi_rq_char_shadow.gif?auto=format,compress",
    summary:
      "I strike from the shadows with toxins and deception, delivering fatal blows 🗡️",
  },
};

export const resultOptionsB: Record<string, Archetype> = {
  "Extraction - Fishing": {
    title: "Fishing",
    caption: "Reel in your riches",
    description:
      "Become a wealthy fisher! Relax by your island estate's shore, or brave the open sea to catch mysterious creatures.  Fishing offers lucrative opportunities and adventure!",
    img: "https://images.prismic.io/imtbl-player-portal/Z6KyCpbqstJ9-Oxu_rq_fishing.gif?auto=format,compress",
    summary:
      "I brave the waters to catch mysterious creatures from depths both shallow and deep, from shoreline to open seas 🎣",
  },
  "Extraction - Mining": {
    title: "Mining",
    caption: "Rock solid rewards",
    description:
      "Mine for riches!  Danger awaits, but skilled miners can unearth valuable ores, minerals, and priceless gemstones.",
    img: "https://images.prismic.io/imtbl-player-portal/Z6KyDJbqstJ9-Oxv_rq_mining.gif?auto=format,compress",
    summary:
      "I delve deep into treacherous caves to unearth precious ores and priceless gemstones of stunning beauty ⛏️",
  },
  "Extraction - Woodcutting": {
    title: "Woodcutting",
    caption: "Timbeeeeeeer",
    description:
      "Chop wood, build greatness!  From willow to mighty oak, your timber fuels ships, carts, homes, and towns. Grab your axe and get to work!",
    img: "https://images.prismic.io/imtbl-player-portal/Z6KyEZbqstJ9-Oxx_rq_woodcutting.gif?auto=format,compress",
    summary:
      "I fell mighty trees from gentle willow to mighty oak to provide wood for ships, homes, and more 🪓",
  },
  "Crafting - Carpentry": {
    title: "Carpentry",
    caption: "Nail it every time",
    description:
      "Carpenters craft everything from furniture to legendary fishing rods and powerful arcane staffs, turning simple planks into masterful creations.",
    img: "https://images.prismic.io/imtbl-player-portal/Z6Kx9pbqstJ9-Oxr_rq_carpentry.gif?auto=format,compress",
    summary:
      "I craft everything from simple furniture to legendary weapons, turning planks into masterful creations 🪚",
  },
  "Crafting - Weaving": {
    title: "Weaving",
    caption: "Fashion, function, and flair",
    description:
      "Craft fabulous attire! From common clothes to magically enchanted garments, weaving cloth and leather requires skill. Follow the trends and style your way to success!",
    img: "https://images.prismic.io/imtbl-player-portal/Z6KyD5bqstJ9-Oxw_rq_weaving.gif?auto=format,compress",
    summary:
      "I create enchanted garments that combine style with magical power, from commonwear to magical attire 🧵",
  },
  "Crafting - Cooking": {
    title: "Cooking",
    caption: "A recipe for greatness",
    description:
      "Become a beloved cook! From cozy meals to adventure snacks, your culinary skills can grant vitality and inspire, pleasing everyone from peasants to kings.",
    img: "https://images.prismic.io/imtbl-player-portal/Z6KyWZbqstJ9-Oxz_rq_snack_cropped.gif?auto=format,compress",
    summary:
      "I create meals that inspire and energize, from simple snacks to royal feasts that grant incredible vitality 👨‍🍳",
  },
  "Crafting - Blacksmithing": {
    title: "Blacksmithing",
    caption: "Steel yourself for greatness",
    description:
      "Forge your legend! Craft everyday gear or become a renowned blacksmith, hammering out a fabled arsenal. From sharp blades to dragon-scale armor, your work shapes life and death.",
    img: "https://images.prismic.io/imtbl-player-portal/Z6KyX5bqstJ9-Ox0_rq_weapon_cropped.gif?auto=format,compress",
    summary:
      "I forge legendary weapons and armor fit for kings, from the sharpest blades to dragon scale armor ⚒️",
  },
  "Agriculture - Moa Breeding": {
    title: "Moa Breeding",
    caption: "Bigger, Faster, rarer, better",
    description:
      "Breed the best Moas! Select top traits and pass them on to create the fastest Moa in RavenQuest.  Find rare feather hues and make other breeders green with envy!",
    img: "https://images.prismic.io/imtbl-player-portal/Z6Kx85bqstJ9-Oxq_rq_breeding.gif?auto=format,compress",
    summary:
      "I breed and raise the fastest and most beautiful Moas in RavenQuest, selecting the finest traits and rarest feathers 🦅",
  },
  "Agriculture - Farming": {
    title: "Farming",
    caption: "Sow much success",
    description:
      "Farm your way to success! Gathering is good, but taming the land and sowing seeds brings greater rewards. Reap valuable crops or feed the hungry—the choice is yours.",
    img: "https://images.prismic.io/imtbl-player-portal/Z6KyCZbqstJ9-Oxt_rq_farming.gif?auto=format,compress",
    summary:
      "I work the land to grow valuable crops and feed the hungry, taming nature for bountiful harvests 🌾",
  },
  "Agriculture - Animal Husbandry": {
    title: "Animal Husbandry",
    caption: "You herd it here first",
    description:
      "Domesticating animals takes patience, but the rewards are plenty.  Set up a farm, care for your livestock, and reap nature's bounty. Be the shepherd of your own and others' lives!",
    img: "https://images.prismic.io/imtbl-player-portal/Z6KyCZbqstJ9-Oxt_rq_farming.gif?auto=format,compress",
    summary:
      "I care for and raise livestock, taming wild creatures into valuable farm animals with a gentle hand 🐎",
  },
};

export const resultOptionsC: Record<string, Archetype> = {
  default: {
    title: "You're a RavenQuest expert",
    caption: "Congrats, you've proven yourself a RavenQuest expert",
    description: "",
    img: "https://images.prismic.io/imtbl-player-portal/Z8aKBBsAHJWomEz7_MunkFinal.gif?auto=format,compress",
    summary:
      "I took the RavenQuest knowledge quiz. How well do YOU know RavenQuest? Take the quiz yourself: https://play.immutable.com/games/ravenquest",
  },
};
